// extracted by mini-css-extract-plugin
export default {"container":"TileColumn_container__5nzby"};